import React, { useEffect, useState }from 'react'
import { HeaderOnlyLayout } from '../../layouts'
import { Icon } from '@fluentui/react/lib/Icon'
import {
  KhubMap,
  MobileFilter,
  MobileFilterButtons,
  MobileFilterPanel,
  Button,
  FilterForm,
} from '../../components'

// When integrate with backend, get this data from database
// import programsDataNoHover from '../../components/khub-map/data/programs-dummy-data-no-hover'
// import programsDataNoZoom from '../../components/khub-map/data/programs-dummy-data-no-zoom'
// import programsDataWithZoom from '../../components/khub-map/data/programs-dummy-data-with-zoom'
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrograms } from '../../features/programs/slice';
import MapHeader from './components/map-header'
import { PageHeader as OrganizationPageHeader } from '../organization-detail/components'
import QueryProvider from '../../features/search/hooks/provider'
import { useHistory, useLocation } from 'react-router'
import qs from 'query-string'
import { Link } from 'react-router-dom'
import { useInternationalization } from '../../features/i18n'
import { useViewport } from '../../utils'
import { SystemProvider } from '../../features/system/provider'
import { MobileFilterButton } from '../../components/MobileFilter/MobileFilterButton.v1'
import { Labels } from '../../components/dashboard-listing/list-filter-labels'
import { setQueryString, emptyAllSelectedCollections } from '../../features/search/slice'

const Filter = () => <Icon iconName="Filter" className="ms-Filter text-xl" />;

const ProgramMap = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const [mapData, setMapData] = useState([])
  const { isOfficial, isVerified} = useSelector(state => state.account)
  const language = useSelector(state => state.system.language)
  const { translate } = useInternationalization()
  const programs = useSelector(state => state.programs.data)
  const ongoingPrograms = useSelector(state => state.programs.data_ongoing_map)
  const completedPrograms = useSelector(state => state.programs.data_completed_map)
  const { isDesktop } = useViewport()

  const [showMap, setShowMap] = useState(true)
  const programsDataWithZoom = useSelector(state => state.programs.data_map_nested)
  const programsDataNoHover = useSelector(state => state.programs.data_map)
  const query = qs.parse(location.search)
  const [lastQueryString, setLastQueryString] = useState(null)

  // Fetch programs
  useEffect(() => {
    if(location.search !== lastQueryString){
      setLastQueryString(location.search)
      dispatch(fetchPrograms(query))
    }
    // eslint-disable-next-line
  }, [dispatch, query])

  useEffect(() => {
    setShowMap(false)

    // Verified user and official member can zoom the map
    if (isVerified || isOfficial) {
      setMapData(programsDataWithZoom)
    } else {
      setMapData(programsDataNoHover)
    }

    setTimeout(() => {
      setShowMap(true)
    }, 300)
  }, [isOfficial, isVerified, programsDataWithZoom, programsDataNoHover])

  const completedProgramLabel = {
    en: 'results for completed programs',
    id: 'hasil untuk program selesai'
  }

  const ongoingProgramLabel = {
    en: 'results for ongoing programs',
    id: 'hasil untuk program berjalan'
  }

  const handleClear = () => {
    dispatch(setQueryString(''))
    dispatch(emptyAllSelectedCollections())

    history.push(location.pathname)
  }

  return (
    <HeaderOnlyLayout>
      {
        query.organization &&
        <OrganizationPageHeader />
      }

      <QueryProvider>
        <MapHeader organizationId={query.organization}/>
      </QueryProvider>

      {
        showMap &&
        <KhubMap
          data={mapData}
          additionalOptions={{
            panControl: true,
            gestureHandling: 'cooperative'
          }}
        >
          <div
            style={{
              background: isDesktop ? `linear-gradient(180deg, rgba(34,34,34,1) 0%, rgba(255,255,255,0) 100%)` : `rgba(0, 0, 0, 0.75)`,
            }}
            className="mb-4 lg:mb-0"
          >
            <div className="container mx-auto">
              <div className="flex items-center justify-between py-5 text-xs text-white">
                <div className="lg:flex items-center">
                  <p className="mr-8" title={`${completedProgramLabel[language.name]}: ${completedPrograms.length} / ${programs.length} program(s).`}>
                    <span style={{marginRight: '5px', width: '10px', height: '10px', backgroundColor: '#52BAE2', display: 'inline-block', borderRadius: '50%'}} />
                    <span className="opacity-75">{completedPrograms.length} {completedProgramLabel[language.name]}</span>
                  </p>
                  <p title={`${ongoingProgramLabel[language.name]}: ${ongoingPrograms.length} / ${programs.length} program(s).`}>
                    <span style={{marginRight: '5px', width: '10px', height: '10px', backgroundColor: '#FF5448', display: 'inline-block', borderRadius: '50%'}} />
                    <span className="opacity-75">{ongoingPrograms.length} {ongoingProgramLabel[language.name]}</span>
                  </p>
                </div>
                <Link to="/organization-map" className="pointer-events-auto">
                  {
                    isDesktop ? (
                      <Button thin className="text-xs">
                        {translate('RELATED', 'view_organization_map')}
                      </Button>
                    ) : (
                      <span className="opacity-75 underline">{translate('RELATED', 'view_organization_map')}</span>
                    )
                  }
                </Link>
              </div>
            </div>
          </div>
        </KhubMap>
      }

      { /* Mobile Filter Button & Panel */ }
      <div className="lg:hidden">
        <MobileFilter>
          <MobileFilterButtons>
            <MobileFilterButton
              query={query}
              filterKey="filters"
            >
              <div className="mr-2">
                <Filter />
              </div>
              <div>Filter</div>
            </MobileFilterButton>
          </MobileFilterButtons>

          <MobileFilterPanel title="Filters" filterKey="filters">
            <div className="pb-48">
              <SystemProvider>
                <FilterForm
                  id="floating-filter-form"
                  query={query}
                />
                <hr className="my-8"/>
                <Labels query={query} wrap/>
                <p className="text-sm text-gray-444 underline mt-4" onClick={handleClear}>
                  {translate('SEARCH', 'clear')}
                </p>
              </SystemProvider>
            </div>
          </MobileFilterPanel>
        </MobileFilter>
      </div>
    </HeaderOnlyLayout>
  )
}

export { ProgramMap }
